import { render, staticRenderFns } from "./no-data-temporarily.vue?vue&type=template&id=4f7a99d7&scoped=true&"
import script from "./no-data-temporarily.vue?vue&type=script&lang=js&"
export * from "./no-data-temporarily.vue?vue&type=script&lang=js&"
import style0 from "./no-data-temporarily.vue?vue&type=style&index=0&id=4f7a99d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a99d7",
  null
  
)

export default component.exports